import { useStorage, createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

const useConfigurablePingProductFunction = function () {
    const visitedConfigurablePingClubs = ref<{
        id: string,
        timestamp: string
    }[]>([])

    if (import.meta.client) {
        useStorage('visited_ping_clubs', visitedConfigurablePingClubs, localStorage)
    }

    async function populateProductList() {
        if (localStorage.getItem('visited_ping_clubs') != null) {
            const storedItems = localStorage.getItem('visited_ping_clubs')
            visitedConfigurablePingClubs.value = JSON.parse(storedItems!)
        }
    }

    function getProduct(id: string) {
        return !!visitedConfigurablePingClubs.value.find((product) => product.id === id)
    }

    async function checkForExpiredStoredProducts() {
        for (const item of visitedConfigurablePingClubs.value) {
            const productIndex = visitedConfigurablePingClubs.value.findIndex(product => product.id === item.id)
            const expirationTime = 60 * 60 * 1000 // 1 hour
            const currentTime = new Date().getTime()

            if (currentTime - parseInt(item.timestamp) > expirationTime) {
                visitedConfigurablePingClubs.value.splice(productIndex, 1)
            }
        }
    }

    async function storeVisitedProductId (id: string) {
        await checkForExpiredStoredProducts()
        if (getProduct(id)) {
            return
        } else {
            const timestamp = new Date().getTime()
            visitedConfigurablePingClubs.value.push(
                {'id': id, 'timestamp': timestamp.toString()}
            )
        }
    }

    return {
        visitedConfigurablePingClubs,
        populateProductList,
        getProduct,
        checkForExpiredStoredProducts,
        storeVisitedProductId
    }
}

export const useConfigurablePingProduct = createSharedComposable(useConfigurablePingProductFunction)
